<!-- 顶部 -->
<template>
  <div class="header-content w-full"
       :class="{index: activePath == '/index'}">
    <div class="index-content-max-width w-full h-full mx-auto flex justify-between px-12 pt-2 items-center text-center">
      <!--  logo+菜单  -->
      <div class="h-full flex gap-x-20 items-center">
        <div class="logo w-50">
          <el-link :href="'/'" :underline="false">LOGO</el-link>
        </div>

        <!--   菜单   -->
        <div class="menu flex gap-x-20 rounded-full items-center pl-16 pr-8" @mouseleave="unpdateMenuHover(activeMenuIndex)">
          <img v-if="activeMenuIndex >=0" ref="menuBgRef" class="menu-bg" src="@/assets/images/header/menu_bg.svg">
          <div class="menu-item flex justify-end items-center" v-for="(menuItem, menuIndex) in menuList" :key="menuItem.title"
               :class="{'active': activeMenuIndex == menuIndex}"
               @mouseenter="unpdateMenuHover(menuIndex)">
            <el-link v-if="!menuItem.children" :href="menuItem.path" :underline="false">{{ $t("www."+menuItem.title) }}</el-link>
            <el-dropdown v-else placement="bottom" class="text-white" popper-class="sub-menu-dropdown" :teleported="false">
              <span class="el-dropdown-link">
                {{ $t("www."+menuItem.title) }}
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-for="submenu in menuItem.children" :key="submenu.title">
                    <el-link :href="submenu.path" :underline="false">{{ $t("www." + submenu.title) }}</el-link>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </div>

      <!--  右侧工具栏  -->
      <div class="tools flex justify-end items-center gap-x-6">
        <el-select class="lang-select h-10" :class="{indexStyle: activePath == '/index'}"
                   :model-value="currentLang"
                   @change="changeLang">
          <el-option
              v-for="item in langsOption"
              :key="item.key"
              :label="item.title"
              :value="item.key"
          />
        </el-select>
        <el-button v-if="!isAuthenticated" round class="header-button login-button h-10 text-white leading-10 text-base border-0 px-10">
          <el-link href="/auth/login" :underline="false">
            {{ $t('www.登录') }}
          </el-link>
        </el-button>
        <el-button v-if="!isAuthenticated" round class="header-button signup-button h-10 leading-10 text-base border-0 px-10">
          <el-link href="/auth/register" :underline="false">
            {{ $t('www.注册') }}
          </el-link>
        </el-button>
        <div v-if="isAuthenticated" class="avatar-name flex items-center">
          <img v-if="userInfo && userInfo.sex == SEX_MAN" class="w-10 h-10" src="@/assets/images/header/man.svg">
          <img v-else class="w-12 h-12" src="@/assets/images/header/woman.svg">
          <span class="text-white text-lg ml-2">{{userInfo && userInfo.surname}}{{userInfo && userInfo.last_name}}</span>
        </div>
        <el-select v-if="isAuthenticated" class="my-account" :placeholder="$t('user.我的账户')">
          <el-option :label="$t('user.我的信息')" value="1" @click="goToProfile(1)"></el-option>
          <el-option :label="$t('user.我的家谱')" value="2" @click="goToProfile(2)"></el-option>
          <el-option :label="$t('user.退出登录')" value="3" @click="goToProfile(3)"></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue';
import {SEX_MAN, SEX_WOMAN} from "@/utils/constants";
import { mapState } from 'vuex'

export default {
  name: "Header",
  setup() {

    return {
      // 顶部菜单
      menuList: [{
        title: '首页',
        path: '/index'
      }, {
        title: '寻根谒祖',
        children: [{
          title: '一键寻根',
          path: '/ancestry'
        },{
          title: '新闻中心',
          path: '/news'
        }]
      },{
        title: '谱牒档案',
        path: '/genealogy'
      },{
        title: '姓氏宗亲',
        path: '/surname'
      },{
        title: '家谱',
        path: '/family-tree'
      }],
      // 切换语言选项
      langsOption: [{
        title: '简体中文',
        lang: 'zh',
        key: 'zh-CN'
      }, {
        title: '繁體中文',
        lang: 'tw',
        key: 'zh-TW'
      }, {
        title: 'English',
        lang: 'en',
        key: 'en'
      }],
      SEX_MAN: SEX_MAN,
      SEX_WOMAN: SEX_WOMAN
    }
  },
  computed: {
    ...mapState({
      // 是否登录
      isAuthenticated: state => !!state.token,
      // 用户信息
      userInfo: state => state.userInfo,
      // 当前语言
      currentLang: state => state.lang
    }),
    // 当前路径
    activePath() {
      return this.$route.path;
    },
    activeMenuIndex() {
      let path = this.$route.fullPath;
      let activeMenuIndex = -1;
      this.menuList.some((menu,index) => {
        if(path.startsWith(menu.path)) {
          activeMenuIndex = index;
          return true;
        }
        if (menu.children && menu.children.some(submenu => path.startsWith(submenu.path))) {
          activeMenuIndex = index;
          return true;
        }
        return false;
      })
      return activeMenuIndex;
    }
  },
  watch: {
    activeMenuIndex() {
      this.unpdateMenuHover(this.activeMenuIndex);
    }
  },
  mounted() {
    this.unpdateMenuHover(this.activeMenuIndex);
  },
  methods: {
    /**
     * 更改语言
     */
    changeLang(value) {
      let selectLangItem = this.langsOption.find(item => item.key == value);
      this.$store.dispatch('langSet', selectLangItem.key).then(res => {
        this.$i18n.locale = selectLangItem.lang;
      }).catch(error => {
      })
    },
    /**
     * 跳转至个人详情页
     * @param value
     */
    goToProfile(value) {
      this.$router.push('/profile?tab=' + value);
    },
    /**
     * 更新hover效果
     * @param menuIndex
     */
    unpdateMenuHover(menuIndex) {
      if (this.$refs && this.$refs.menuBgRef) {
        this.$refs.menuBgRef.style['-webkit-transform'] = 'translate(' + (menuIndex * 9 - 2.9) + 'rem,-50%)'
      }
    }
  }
}
</script>

<style scoped lang="scss">
// 顶部
.header-content {
  background-color: var(--darker-blue);
  border-bottom-left-radius: calc(var(--header-height) / 2);
  border-bottom-right-radius: calc(var(--header-height) / 2);
  height: var(--header-height);

  .logo {

    ::v-deep .el-link {
      color: white;
      font-size: 3rem;
      font-weight: bold;
    }
  }

  .menu {
    background-color: transparent;
    height: calc(var(--header-height) - 1.5rem);
    position: relative;

    .menu-bg {
      height: 72%;
      width: auto;
      position: absolute;
      top: 50%;
      transform: translate(-2.9rem, -50%);
      transition: all 0.3s ease;
    }

    .menu-item {
      width: 4rem;
      height: 72%;
      line-height: 100%;
      position: relative;
      text-align: center;

      .el-link {
        color: white;
        font-weight: normal;
        width: 100%;
      }

      .el-dropdown {
        .el-dropdown-link:focus-visible {
          outline: unset;
        }
      }
    }
  }

  // 右侧工具栏
  .tools {

    .header-button {
      padding: 1rem 2rem;
    }

    .login-button {
      background-color: var(--dark-grey);

      &:hover {
        background-color: var(--grey-1);
      }

      ::v-deep .el-link {
        color: white;
      }
    }

    .signup-button {
      background-color: var(--middle-grey);

      &:hover {
        background-color: var(--grey-2);
      }

      ::v-deep .el-link {
        color: var(--el-button-text-color);
      }
    }

    ::v-deep .el-select {
      width: 9rem;
      position: relative;

      .el-select__wrapper {
        border-radius: 9999px;
        background-color: transparent;
        padding-right: 0.8rem;
        box-shadow: 0 0 0 0.06rem var(--dark-grey) inset;
        height: 2.5rem;
        line-height: 2.5rem;
        font-size: 0.875rem;

        .el-icon {
          color: var(--dark-grey);
        }

        &.is-focused {
          box-shadow: 0 0 0 0.06rem var(--dark-grey) inset;
        }

        .el-select__placeholder {
          color: var(--dark-grey);
        }
      }

      &.lang-select .el-select__wrapper::before {
        content: "";
        width: 2.5rem;
        height: 2.5rem;
        top: 0;
        right: 0;
        border-radius: 50%;
        border: 0.06rem solid var(--dark-grey);
        position: absolute;
      }

      &.indexStyle {

        .el-select__wrapper {

          box-shadow: 0 0 0 0.06rem white inset;

          .el-icon {
            color: white;
          }
          .el-select__placeholder {
            color: white;
          }

          &::before {
            border-color: white;
          }
        }

      }
    }

    ::v-deep .el-select.my-account {
      width: 5.5rem;
      padding: 0;

      .el-select__wrapper {
        box-shadow: unset;
        padding: 0;

        .el-select__placeholder {
          color: var(--lighter-grey);
        }

        .el-icon {
          color: var(--lighter-grey);
        }
      }
    }

    ::v-deep .el-button + .el-button {
      margin-left: 0;
    }

  }

  // 首页顶部
  &.index {
    background-color: transparent;

    .logo {

      ::v-deep .el-link {
        color: var(--darker-blue);
      }
    }

    .menu {
      background-color: var(--lighter-grey);

      .menu-item{
        .el-link {
          color: black;
        }

        .el-dropdown {
          color: black;
        }
      }
    }

    .login-button {
      background-color: var(--dark-orange);

      &:hover {
        background-color: var(--light-orange);
      }
    }

    .signup-button {
      background-color: white;

      &:hover {
        background-color: rgba(255, 255, 255, 0.9);
      }
    }
  }
}
</style>
